import React, { ReactNode } from 'react';

import TableCell from '@mui/material/TableCell';

import { StyledTableRow } from './StyledTable';

import { PlainObject } from '../data_types/types';


interface ComponentProps {
    label: string | ReactNode;
    value: any;
    valueColor?: string;
    thSx?: PlainObject;
    tdSx?: PlainObject;
};


const SummaryDataTableRow:React.FC<ComponentProps> = ({ label, value, valueColor, thSx, tdSx })=> (
    <StyledTableRow>
        <TableCell component="th" scope="row" sx={{ color: theme => theme.palette.text.secondary, ...thSx }}>
            { label }
        </TableCell>

        <TableCell component="td" scope="row" sx={{ color: valueColor, textAlign: 'right', ...tdSx }}>
            { value }
        </TableCell>
    </StyledTableRow>
);

export default SummaryDataTableRow;
